import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

// Loader Components
import showLoader from '@components/loader';

export const getPurpose = createAsyncThunk('purposeSlice/getPurpose', async () => {
    try {
        let response = await axios.get('/purpose', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getPurposeOption = createAsyncThunk('purposeSlice/getPurposeOption', async () => {
    try {
        showLoader(true);
        let response = await axios.get('/purpose?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createPurpose = createAsyncThunk('purposeSlice/createPurpose', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.post('/purpose', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Purpose created successfully.');
        dispatch(getPurpose());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updatePurpose = createAsyncThunk('purposeSlice/updatePurpose', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/purpose/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Purpose updated successfully.');
        dispatch(getPurpose());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deletePurpose = createAsyncThunk('purposeSlice/deletePurpose', async (deleteId, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.delete('/purpose/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Purpose deleted successfully');
        dispatch(getPurpose());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updatePurposeStatus = createAsyncThunk('purposeSlice/updatePurposeStatus', async (id, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/purpose/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status updated successfully.');
        dispatch(getPurpose());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.err(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const purposeSlice = createSlice({
    name: 'purposeSlice',
    initialState: {
        data: [],
        option: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getPurpose.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getPurposeOption.fulfilled, (state, action) => {
            state.option = action.payload;
            return;
        });
    }
});

export default purposeSlice.reducer;
